export const model = 'claude-haiku-4-5-20251001'
export const maxTokens = 2048
export const maxToolIterations = 5

export const greeting = "Welcome to hive. I'm Claudio, your personal shopping assistant — here to help you explore our collection, learn about the designers and brands we carry. Where shall we start?"

export const placeholder = "Tell me what you're looking for..."
